import React, { useEffect, useState } from 'react';
import { TrendingUp, TrendingDown, Activity } from 'lucide-react';
import api from '../../services/api';

/**
 * Hero 右侧浮动交易卡片 — 只读 4 条最新交易，不修改任何行情/交易接口。
 * 数据源与 TradeRecords 相同：GET /api/trades
 */
const HeroTradeCards = () => {
  const [trades, setTrades] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/trades', { params: { limit: 8 } })
      .then((res) => {
        if (cancelled) return;
        const list = res?.data?.success ? res?.data?.data?.trades || [] : [];
        setTrades(list.slice(0, 4));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const formatChange = (t) => {
    const ratio = parseFloat(t.pnlRatio);
    if (Number.isFinite(ratio)) return ratio;
    const entry = parseFloat(t.entryPrice);
    const exit = parseFloat(t.exitPrice) || parseFloat(t.currentPrice);
    if (entry > 0 && exit > 0) return ((exit - entry) / entry) * 100;
    return 0;
  };

  const priceOf = (t) => {
    const p =
      parseFloat(t.currentPrice) ||
      parseFloat(t.exitPrice) ||
      parseFloat(t.entryPrice) ||
      0;
    return p.toFixed(2);
  };

  const skeletons = [0, 1, 2, 3];
  const items = trades.length ? trades : skeletons.map((i) => ({ __skeleton: true, id: `sk-${i}` }));

  return (
    <div className="hero-cards" aria-hidden={trades.length === 0 ? 'true' : 'false'}>
      {items.map((t, idx) => {
        if (t.__skeleton) {
          return (
            <div key={t.id} className={`hero-card hero-card--skeleton hero-card--slot-${idx}`} />
          );
        }
        const ratio = formatChange(t);
        const up = ratio >= 0;
        const TrendIcon = up ? TrendingUp : TrendingDown;
        return (
          <div
            key={t.id}
            className={`hero-card hero-card--slot-${idx} ${up ? 'hero-card--up' : 'hero-card--down'}`}
          >
            <div className="hero-card__top">
              <div className="hero-card__sym">
                <span className="hero-card__sym-code">{t.symbol}</span>
                <span className="hero-card__sym-market">{t.market || 'NASDAQ'}</span>
              </div>
              <div className={`hero-card__badge ${up ? 'hero-card__badge--up' : 'hero-card__badge--down'}`}>
                <TrendIcon size={12} strokeWidth={2.5} />
                <span>{up ? '+' : ''}{ratio.toFixed(2)}%</span>
              </div>
            </div>
            <div className="hero-card__price">${priceOf(t)}</div>
            <div className="hero-card__foot">
              <span className="hero-card__live">
                <Activity size={10} />
                LIVE
              </span>
              <span className="hero-card__qty">Qty · {t.quantity?.toLocaleString() || 0}</span>
            </div>
            <svg className="hero-card__spark" viewBox="0 0 100 30" preserveAspectRatio="none" aria-hidden="true">
              <polyline
                points={
                  up
                    ? '0,24 15,20 30,22 45,16 60,18 75,10 90,12 100,6'
                    : '0,8 15,10 30,7 45,14 60,12 75,20 90,18 100,24'
                }
                fill="none"
                strokeWidth="2"
                stroke={up ? '#22c55e' : '#f43f5e'}
                opacity="0.85"
              />
            </svg>
          </div>
        );
      })}
    </div>
  );
};

export default HeroTradeCards;
